import { Box, Tooltip } from '@mui/material';
import type React from 'react';

import DeviceStatusIcon from '@/components/DeviceStatusIcon';

import type { StatusIconWithTooltipProps } from './StatusIconWithTooltip.types';

/**
 * Reusable component for rendering a device status icon with tooltip
 * Used in name cell renderers across different table implementations
 */
const StatusIconWithTooltip: React.FC<StatusIconWithTooltipProps> = ({
  status,
  statusLabel,
  deviceType,
  tooltipClasses,
  iconClassName
}) => {
  return (
    <Tooltip
      arrow
      placement="right"
      title={statusLabel || ''}
      classes={tooltipClasses}
    >
      <Box
        className={iconClassName}
        sx={{ display: 'inline-flex', alignItems: 'center' }}
      >
        <DeviceStatusIcon deviceType={deviceType} status={status} />
      </Box>
    </Tooltip>
  );
};

export default StatusIconWithTooltip;
